import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import bell from "../../images/notification.svg";
import users from "../../images/userMes.svg";
import chatnew from "../../images/edit.svg";
import "./HeaderScreen.scss"; // Ensure this path is correct

const HeaderScreen = () => {
  const location = useLocation();
  const [isSearch, setIsSearch] = useState(true);
  const [tag, setTag] = useState("pdf");

  const handleToggle = () => {
    setIsSearch((isSearch) => !isSearch);
    setTag(isSearch ? "pdf" : "url");
  };

  return (
    <div className="header-screen">
      <div className="row">
        <div className="col-sm-10">
          {location.pathname === "/chat" && (
            <div className="new-chat">
              <img src={chatnew} alt="New Chat" className="header-icon" />
              <div className="new-chat-text">New Chat</div>
            </div>
          )}
        </div>
        <div className="col-sm-2">
          {location.pathname === "/chat" && (
            <div className="toggle-section">
              <span className="toggle-label">Search URL:</span>
              <button
                className="toggle-switch"
                onClick={handleToggle}
                style={{
                  marginRight: "10px",
                  backgroundColor: "grey",
                  color: "white",
                  border: "none",
                  borderRadius: "20px",
                  width: "40px",
                  height: "20px",
                  position: "relative",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    backgroundColor: "white",
                    borderRadius: "50%",
                    width: "18px",
                    height: "18px",
                    position: "absolute",
                    top: "1px",
                    left: isSearch ? "1px" : "21px",
                    transition: "left 0.3s",
                  }}
                />
              </button>
            </div>
          )}
          <img src={bell} alt="Bell" className="header-icon" />
          <img src={users} alt="User" className="header-icon" />
        </div>
      </div>
    </div>
  );
};

export default HeaderScreen;
